import { SubsApiAction } from 'actions/SubsApiAction'
import { UserApiAction } from 'actions/UserApiAction'
import { Me } from 'models/Me'
import { Resource } from 'models/Resource'
import { useState } from 'react'
import { useOneShot } from 'hooks/useOneShot'

export type MeState = Resource<Me>

const initialState: MeState = Resource.loading()

const fetch = async (setState: (value: MeState) => void) => {
    try {
        const [user, isSubsOpen, subsChannelProducts] = await Promise.all([
            UserApiAction.getMyUser(),
            SubsApiAction.getIsMySubsOpen(),
            SubsApiAction.getMySubsProducts()
        ])
        const me = new Me({user, isSubsOpen, subsChannelProducts})
        setState(Resource.of(me))
    } catch (e: unknown) {
        setState(Resource.failure(e))
    }
}

export const useMe: () => MeState = () => {
    const [state, setState] = useState(initialState)
    useOneShot(() => {
        fetch(setState)
    })
    return state
}
